import { render, staticRenderFns } from "./dialogRelatorios.vue?vue&type=template&id=88d758cc&scoped=true"
import script from "./dialogRelatorios.vue?vue&type=script&lang=js"
export * from "./dialogRelatorios.vue?vue&type=script&lang=js"
import style0 from "./dialogRelatorios.vue?vue&type=style&index=0&id=88d758cc&prod&scoped=true&lang=css"
import style1 from "./dialogRelatorios.vue?vue&type=style&index=1&id=88d758cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d758cc",
  null
  
)

export default component.exports